import { render, staticRenderFns } from "./studentDebtInfo.vue?vue&type=template&id=b0f9278a&"
import script from "./studentDebtInfo.vue?vue&type=script&lang=ts&"
export * from "./studentDebtInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports